import api from 'api';

const url = id => `/api/reservations/${id}`;

export default {
    validate: id => api.get({path: url(id)}),
    update: (id, params) => api.patch({path: url(id), params})
}